import React from "react";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import PropTypes from "prop-types";

const colorCss = config.css.color;
const fontCss = config.css.fontThickness;

const BUTTON_HEIGHT_PX = 40;
const FONT_SIZE_PX = 14;

const css = {
  googleButton: {
    width: "100%",
    height: BUTTON_HEIGHT_PX,
    borderRadius: 0,
    border: "1px solid #d8d8d8",
    backgroundColor: "#ffffff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    cursor: "pointer",
    padding: "0 16px",
    boxSizing: "border-box"
  },
  googleIconWrap: {
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  googleButtonText: {
    fontSize: FONT_SIZE_PX,
    fontWeight: fontCss.bold,
    color: "#222222"
  },
  emailButton: {
    width: "100%",
    height: BUTTON_HEIGHT_PX,
    border: "none",
    borderRadius: 0,
    backgroundColor: colorCss.backgroundColorOfSelectContainedButton,
    color: colorCss.colorOfSelectContainedButton,
    fontSize: FONT_SIZE_PX,
    fontWeight: fontCss.bold,
    cursor: "pointer"
  }
};

CommonAuthButtonView.propTypes = {
  btnType: PropTypes.oneOf(["google", "email"]).isRequired,
  onClick: PropTypes.func.isRequired
};

function CommonAuthButtonView(props) {
  const { btnType, onClick } = props;

  const handleButtonClick = () => {
    onClick();
  };

  const getGoogleButton = () => {
    return (
      <button
        type="button"
        onClick={handleButtonClick}
        style={css.googleButton}
      >
        <span style={css.googleIconWrap} aria-hidden="true">
          <svg
            width="18"
            height="18"
            viewBox="0 0 48 48"
            role="img"
            aria-hidden="true"
          >
            <path
              fill="#FFC107"
              d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12S17.4 12 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.9 6.1 29.2 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5Z"
            />
            <path
              fill="#FF3D00"
              d="M6.3 14.7l6.6 4.8C14.7 15.2 18.9 12 24 12c3 0 5.7 1.1 7.8 3l5.7-5.7C33.9 6.1 29.2 4 24 4c-7.7 0-14.4 4.3-17.7 10.7Z"
            />
            <path
              fill="#4CAF50"
              d="M24 44c5.1 0 9.8-2 13.3-5.2l-6.1-5.2c-2 1.5-4.4 2.4-7.2 2.4-5.3 0-9.7-3.3-11.4-8l-6.5 5C9.3 39.6 16 44 24 44Z"
            />
            <path
              fill="#1976D2"
              d="M43.6 20.5H42V20H24v8h11.3c-1.1 3.1-3.3 5.5-6.1 6.8l.1.1 6.1 5.2C35 39.7 44 33 44 24c0-1.3-.1-2.4-.4-3.5Z"
            />
          </svg>
        </span>
        <span style={css.googleButtonText}>
          <TXT name="btnCommonContained_logInViaGoogle" />
        </span>
      </button>
    );
  };

  const getEmailButton = () => {
    return (
      <button type="button" onClick={handleButtonClick} style={css.emailButton}>
        <TXT name="btnCommonContained_logInViaEmail" />
      </button>
    );
  };

  return (
    <div>
      {btnType === "google" && getGoogleButton()}
      {btnType === "email" && getEmailButton()}
    </div>
  );
}

export default CommonAuthButtonView;
